import { AddReactionButton } from './AddReactionButton';
import { ReactionsMap, EmojiIcon } from '../utils/reactionsData';
import { observer } from 'mobx-react-lite';
import { ClientItemId } from 'owa-client-ids';
import { ClientItem } from 'owa-mail-store';
import { InstrumentationContext } from 'owa-search/lib/types/InstrumentationContext';
import * as React from 'react';
import { Callout, DirectionalHint } from '@fluentui/react/lib/Callout';
import { IconButton, IButton } from '@fluentui/react/lib/Button';
import Message from 'owa-service/lib/contract/Message';
import { Reaction_AddReaction_Title } from '../utils/reactions.locstring.json';
import getOwnerReactionType from '../utils/getOwnerReactionType';
import loc from 'owa-localize';
import { useBooleanState } from 'owa-react-hooks/lib/useBooleanState';
import { FocusZone, FocusZoneDirection } from '@fluentui/react/lib/FocusZone';

const styles = require('./Reactions.scss');
const classNames = require('classnames');
export interface ReactionActionButtonProps {
    conversationId: ClientItemId;
    itemId: ClientItemId;
    item: ClientItem;
    instrumentationContext: InstrumentationContext;
}

export const ReactionActionButton = observer(function ReactionActionButton(
    props: ReactionActionButtonProps
) {
    const divRef = React.useRef<HTMLDivElement>();
    const buttonRef = React.useRef<IButton>();
    let showTimeout: ReturnType<typeof setTimeout> = null;
    let hideTimeout: ReturnType<typeof setTimeout> = null;
    const [isCalloutVisible, showCallout, hideCallout] = useBooleanState(false);

    const getAllReactions = (): JSX.Element[] => {
        const reactions: JSX.Element[] = [];
        const allReactions = Object.keys(ReactionsMap);
        const message: Message = props.item as Message;
        const ownerCurrentReactionType = getOwnerReactionType(message);

        allReactions.forEach(reactionType => {
            reactions.push(
                <AddReactionButton
                    key={reactionType}
                    message={message}
                    conversationId={props.conversationId}
                    itemId={props.itemId}
                    reactionType={reactionType}
                    onAddReactionClicked={dismissCallout}
                    instrumentationContext={props.instrumentationContext}
                    ownerCurrentReactionType={ownerCurrentReactionType}></AddReactionButton>
            );
        });

        return reactions;
    };

    const onReactionActionButtonClick = (event?: React.MouseEvent<{}>) => {
        showCallout();
        event.stopPropagation();
        event.preventDefault();
    };

    const onMouseEnter = () => {
        clearTimeout(showTimeout);
        clearTimeout(hideTimeout);

        showTimeout = setTimeout(() => {
            showCallout();
        }, 400);
    };
    const onMouseLeave = () => {
        clearTimeout(showTimeout);
        clearTimeout(hideTimeout);

        hideTimeout = setTimeout(() => {
            dismissCallout();
        }, 150);
    };
    const dismissCallout = () => {
        hideCallout();
        setTimeout(() => {
            buttonRef.current.focus();
        }, 0);
    };
    const buttonStyle = classNames(
        styles.reactionActionButton,
        isCalloutVisible && styles.reactionActionButtonActive
    );

    return (
        <div ref={divRef}>
            <IconButton
                componentRef={buttonRef}
                iconProps={EmojiIcon}
                className={buttonStyle}
                styles={{ icon: styles.addReactionIcon }}
                ariaLabel={loc(Reaction_AddReaction_Title)}
                role={'menuitem'}
                onClick={onReactionActionButtonClick}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
            />

            <Callout
                target={divRef}
                hidden={!isCalloutVisible}
                isBeakVisible={false}
                setInitialFocus={true}
                gapSpace={1}
                directionalHint={DirectionalHint.topRightEdge}
                onDismiss={dismissCallout}>
                <div
                    className={styles.reactionsCalloutContainer}
                    onMouseEnter={onMouseEnter}
                    onMouseLeave={onMouseLeave}>
                    <FocusZone direction={FocusZoneDirection.horizontal}>
                        {getAllReactions()}
                    </FocusZone>
                </div>
            </Callout>
        </div>
    );
});
